function reducer(state = [], action) {

    switch (action.type) {
        case 'NETWORK/SET':
            return action.network;
        default:
            return state;
    }
}

export default reducer;